import { Progress, Space } from 'antd';
import styles from '../index.module.scss';
import { DeviceRankItem, RightStatisticData } from '../types';
import { COLORS } from '../constants';
import { keepPercentOrLine, keepPercentTwoUndfined, keepTwoNull } from '@/utils/utils';
import circleImg from '@/assets/images/circle@2x.png';

interface StatisticsCardProps {
  pageLabel?: string;
  selectedDevice?: DeviceRankItem;
  statistics?: RightStatisticData;
}
const StatisticsCard = ({ pageLabel, selectedDevice, statistics }: StatisticsCardProps) => {
  return (
    <div className={styles.statisticsSection}>
      {selectedDevice && (
        <span className={`${styles.rankNumber} ${styles[`rankNumber_${selectedDevice?.rank}`]}`}>
          {selectedDevice?.rank}
        </span>
      )}

      <div className={styles.name}> {selectedDevice?.deviceName ?? '--'}</div>
      <div className={styles.statisticsPeriod}>
        统计周期：
        <span
          style={{
            display: 'inline-block',
            padding: 8,
            background: 'var(--mx-card-dark-bg-color)',
            borderRadius: 2,
            fontWeight: 500,
            fontSize: 16,
            color: 'var(--mx-diagram1-color)',
          }}
        >
          {statistics?.days ?? '--'}天
        </span>
      </div>
      <div className={styles.statisticsContent}>
        <div className={styles.item}>
          <div style={{ position: 'relative' }}>
            <Progress
              type="circle"
              size={40}
              percent={keepPercentTwoUndfined(statistics?.conditionProportion)}
              trailColor={COLORS.nonLongFlow}
              strokeColor={COLORS.longFlow}
              showInfo={false}
            />
            <img src={circleImg} width={26} style={{ position: 'absolute', left: 7, top: 7 }} />
          </div>
          <Space size={4} direction="vertical" style={{ marginLeft: 10 }}>
            <Space size={16}>
              <span style={{ display: 'inline-block', width: 88 }}>{pageLabel}天数:</span>
              <span style={{ fontWeight: 500, color: 'var(--mx-text-base-color)' }}>
                {statistics?.conditionCount ?? '--'}天
              </span>
              <span style={{ color: '#FF9247' }}>{keepPercentOrLine(statistics?.conditionProportion)}%</span>
            </Space>
            <Space size={16}>
              <span style={{ display: 'inline-block', width: 88 }}>非{pageLabel}天数:</span>
              <span style={{ fontWeight: 500, color: 'var(--mx-text-base-color)' }}>
                {statistics?.unConditionCount ?? '--'}天
              </span>
              <span style={{ color: '#00ADFF' }}>{keepPercentOrLine(statistics?.unConditionProportion)}%</span>
            </Space>
          </Space>
        </div>
        <div className={styles.item} style={{ flexDirection: 'column' }}>
          <Space size={16}>
            <span style={{ display: 'inline-block', width: 158 }}>{pageLabel}平均每小时用量:</span>
            <span style={{ fontWeight: 500, color: 'var(--mx-text-base-color)' }}>
              {keepTwoNull(statistics?.conditionUsageAvg)}m³/h
            </span>
          </Space>
          <Space size={16}>
            <span style={{ display: 'inline-block', width: 158 }}>非{pageLabel}平均每小时用量:</span>
            <span style={{ fontWeight: 500, color: 'var(--mx-text-base-color)' }}>
              {keepTwoNull(statistics?.unConditionUsageAvg)}m³/h
            </span>
          </Space>
        </div>
      </div>
    </div>
  );
};
export default StatisticsCard;
